import { ChangeDetectorRef, Component, Input, ViewContainerRef } from '@angular/core';
import { QuestionAngular } from 'survey-angular-ui';
import { Question } from 'survey-core';
import { QuestionsService } from '../../../core/services/survey/questions.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SurveyService } from '../../../core/services/survey/survey.service';

@Component({
  selector: 'tgf-office-search-widget',
  template: '',
})
export class TangillaQuestion<T extends Question = Question> extends QuestionAngular<T> {
  @Input() form!: FormGroup;
  @Input() inputModel: any;
  @Input() parentModel: any;
  @Input() inputName?: string;

  @Input() previousQuestionsToGetValueFrom?: { [key: string]: string };

  showTitle = true;
  formWidgetJson: any;
  namesReplacements: any;
  questionForm!: FormGroup;

  scrollTopOnFormInvalid = false;

  constructor(
    protected formBuilder: FormBuilder,
    protected surveyService: SurveyService,
    protected questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef
  ) {
    super(changeDetectorRef, viewContainerRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initializeQuestionModelRelatedProperties();
    this.questionForm = this.form ? this.form : this.formBuilder.group({}, {
        updateOn: 'blur'
      }
    );
    this.processFirstTimeRendered();
  }

  initializeQuestionModelRelatedProperties() {
    this.namesReplacements = this.questionModel?.jsonObj?.namesReplacements;
    this.showTitle = this.questionModel?.jsonObj?.showTitle !== false;
  }

  private processFirstTimeRendered() {
    const question = this.questionsService.getQuestion(this.questionName);
    if (question) {
      if (question['firstTimeRendered'] === undefined) {
        question['firstTimeRendered'] = true;
      } else {
        question['firstTimeRendered'] = false;
      }
    }
  }

  addFormControl(
    controlName: string,
    questionName: string,
    validators: Array<any> = [],
    value: any = null,
    disabled: boolean = false
  ) {
    const question = this.questionsService.getQuestion(questionName);

    const formControlValue = question && question.value ? question.value : value;
    this.questionForm.addControl(controlName, new FormControl({value: formControlValue, disabled}, validators));
  }

  protected setFormControlValue(controlName: string, value: any) {
    this.questionForm.get(controlName)?.setValue(value);
    this.questionForm.get(controlName)?.markAsTouched();
  }

  protected submitForm(submitFunction: () => any) {
    if (this.questionForm.valid) {
      submitFunction();
    } else {
      for (const controlName in this.questionForm.controls) {
        this.questionForm.get(controlName)?.markAsTouched();
        this.changeDetectorRef.detectChanges();
      }
      if (this.scrollTopOnFormInvalid) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }

  getQuestionName(nameReplacement: string, defaultName?: string) {
    return this.namesReplacements?.[nameReplacement] || defaultName || nameReplacement;
  }

  getQuestionValue(nameReplacement: string, defaultName?: string) {
    const widgetQuestion = this.questionsService.getQuestion(this.actualModel?.name);

    if (widgetQuestion && widgetQuestion['firstTimeRendered'] &&
      this.questionModel?.jsonObj?.defaultValueQuestionNames) {
      const defaultValueQuestion = this.questionsService.getQuestion(this.questionModel?.jsonObj?.defaultValueQuestionNames[nameReplacement]);
      return defaultValueQuestion?.value || null;
    }

    return this.questionsService.getQuestion(this.namesReplacements?.[nameReplacement] || defaultName || nameReplacement)?.value || null;
  }

  get questionName() {
    return this.inputName || this.model?.name;
  }

  get questionModel() {
    return this.inputModel || this.model;
  }

  get actualModel() {
    return this.parentModel || this.model || this.inputModel;
  }

  getValueFromPreviousQuestion(questionName: string) {
    if (this.previousQuestionsToGetValueFrom && this.previousQuestionsToGetValueFrom[questionName] && this.questionsService.getQuestion(this.previousQuestionsToGetValueFrom[questionName])) {
      return this.questionsService.getQuestion(this.previousQuestionsToGetValueFrom[questionName]).value;
    }
    return null;
  }
}
